import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import { userIsAdminAtom } from "@/modules/user/userApi.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { Trans } from "@lingui/react/macro";

export function AdminUserWarning() {
    //#region Hooks
    const isAdmin = useSuspenseQueryAtom(userIsAdminAtom);

    return (
        isAdmin && (
            <NoticeBlock icon="jp-warning-icon" color="error">
                <p>
                    <b className="uppercase">
                        <Trans>Warning</Trans>
                    </b>
                    <br />
                    <Trans>
                        You are an administrator and are about to delegate your administrative privileges to another
                        user. Please ensure this action is intentional.
                    </Trans>
                </p>
            </NoticeBlock>
        )
    );
}
